import React from 'react';
import PropTypes from 'prop-types';
import Error from '.';

// Render the generic technical-issue message instead of leaking raw JS error text.
function ErrorFallbackComponent({ error }) {
  return <Error error={error} />;
}

ErrorFallbackComponent.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
};

ErrorFallbackComponent.defaultProps = {
  error: {
    message: null,
  },
};

export default ErrorFallbackComponent;
